(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["addon-product-styles"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('change', function (event) {
      const checkbox = event.target.closest(
        ".addon-product__dpl_grid input[type='checkbox']"
      );

      if (!checkbox) return;

      window.productIds = Array.from(
        document.querySelectorAll(
          ".addon-product__dpl_grid input[type='checkbox']:checked"
        )
      ).map(box => box.value);
    });

    document.addEventListener('click', function (event) {
      const trigger = event.target.closest('.add_to_cart_trigger');

      if (!trigger) return;

      const submitButton = document.querySelector('.product-form__submit');

      if (submitButton) {
        submitButton.click();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bundle-choice-ab"] && !Shopify.designMode) return;
  try {
    (function () {
    var ATTR = 'data-bundle-choice-ab';
    var cfg = document.querySelector('[data-jc-kaching-style]');
    if (!cfg || !document.body) return;

    document.body.classList.add('jc-kaching-bundle-page');
    var bundleLabel = cfg.getAttribute('data-bundle-label') || 'Bundle';
    var discountWord = cfg.getAttribute('data-discount-word') || 'discount';
    var scheduled = false;
    var userPicked = false;
    var lastMode = null;

    function isOn() {
      return document.body.getAttribute(ATTR) === 'true';
    }

    document.addEventListener(
      'click',
      function (event) {
        if (!event.isTrusted || !event.target.closest) return;
        if (event.target.closest('.kaching-bundles__bar')) userPicked = true;
      },
      true
    );

    function dealBar(root, wantBundle) {
      var match = null;
      root.querySelectorAll('.kaching-bundles__bar').forEach(function (bar) {
        var isBundle = !!bar.querySelector('.kaching-bundles__bundle-products');
        if (isBundle === wantBundle) match = bar;
      });
      return match;
    }

    function selectDefault(root) {
      var wantBundle = isOn();
      var mode = wantBundle ? 'bundle' : 'single';
      if (lastMode !== mode) {
        lastMode = mode;
        userPicked = false;
      }
      if (wantBundle && userPicked) return;
      var bar = dealBar(root, wantBundle);
      if (!bar || bar.classList.contains('kaching-bundles__bar--selected')) return;
      var radio = bar.querySelector('input[type="radio"]');
      if (radio) radio.click();
      else bar.click();
    }

    function parseMoney(text) {
      var value = String(text || '').replace(/\s/g, '').replace(/[^\d,.-]/g, '');
      if (!value) return NaN;
      var comma = value.lastIndexOf(',');
      var dot = value.lastIndexOf('.');
      if (comma !== -1 && dot !== -1) {
        value = comma > dot ? value.replace(/\./g, '').replace(',', '.') : value.replace(/,/g, '');
      } else if (comma !== -1) {
        value = value.replace(',', '.');
      }
      var amount = parseFloat(value);
      return isNaN(amount) ? NaN : amount;
    }

    function discountPercent(priceEl, fullEl) {
      if (!priceEl || !fullEl) return 0;
      var price = parseMoney(priceEl.textContent);
      var full = parseMoney(fullEl.textContent);
      if (!full || !price || full <= price) return 0;
      return Math.round(((full - price) / full) * 100);
    }

    function setPill(parent, percent, before) {
      var pill = parent.querySelector(':scope > .jc-kaching-pill');
      if (!percent) {
        if (pill) pill.remove();
        return;
      }
      var label = percent + '% ' + discountWord;
      if (!pill) {
        pill = document.createElement('span');
        pill.className = 'jc-kaching-pill';
        if (before && before.parentNode === parent) parent.insertBefore(pill, before);
        else parent.appendChild(pill);
      }
      if (pill.textContent !== label) pill.textContent = label;
    }

    function restore(root) {
      root.querySelectorAll('[data-jc-original]').forEach(function (node) {
        node.textContent = node.getAttribute('data-jc-original');
        node.removeAttribute('data-jc-original');
      });
      root.querySelectorAll('.jc-kaching-pill, .jc-kaching-injected-image').forEach(function (node) {
        node.remove();
      });
      root.querySelectorAll('.jc-kaching-bar--single, .jc-kaching-bar--bundle').forEach(function (bar) {
        bar.classList.remove('jc-kaching-bar--single', 'jc-kaching-bar--bundle');
      });
    }

    function decorate(root) {
      selectDefault(root);
      if (!isOn()) {
        restore(root);
        return;
      }

      root.querySelectorAll('.kaching-bundles__bar').forEach(function (bar) {
        var isBundle = !!bar.querySelector('.kaching-bundles__bundle-products');
        bar.classList.toggle('jc-kaching-bar--bundle', isBundle);
        bar.classList.toggle('jc-kaching-bar--single', !isBundle);
      });

      var single = root.querySelector('.jc-kaching-bar--single');
      if (single) {
        var main = single.querySelector('.kaching-bundles__bar-main');
        if (main && !main.querySelector('.kaching-bundles__bar-image, .jc-kaching-injected-image')) {
          var source = root.querySelector('.kaching-bundles__bundle-products__image');
          var sourceSrc = source && (source.currentSrc || source.src || source.getAttribute('src'));
          if (sourceSrc) {
            var image = document.createElement('img');
            image.className = 'kaching-bundles__bar-image jc-kaching-injected-image';
            image.alt = source.alt || '';
            image.src = sourceSrc;
            var radio = main.querySelector('.kaching-bundles__bar-radio');
            if (radio) radio.insertAdjacentElement('afterend', image);
            else main.insertBefore(image, main.firstChild);
          }
        }
        var singleCopy = single.querySelector('.kaching-bundles__bar-content-left') || single.querySelector('.kaching-bundles__bar-content');
        if (singleCopy) {
          setPill(
            singleCopy,
            discountPercent(
              single.querySelector('.kaching-bundles__bar-main .kaching-bundles__bar-price'),
              single.querySelector('.kaching-bundles__bar-main .kaching-bundles__bar-full-price')
            )
          );
        }
      }

      var bundle = root.querySelector('.jc-kaching-bar--bundle');
      if (bundle) {
        var title = bundle.querySelector('.kaching-bundles__bar-main .kaching-bundles__bar-title');
        if (title && title.textContent.trim() !== bundleLabel) {
          if (!title.hasAttribute('data-jc-original')) title.setAttribute('data-jc-original', title.textContent);
          title.textContent = bundleLabel;
        }
        bundle.querySelectorAll('.kaching-bundles__bundle-products__product').forEach(function (product) {
          setPill(
            product,
            discountPercent(
              product.querySelector('.kaching-bundles__bundle-products__price'),
              product.querySelector('.kaching-bundles__bundle-products__full-price')
            ),
            product.querySelector('.kaching-bundles__bundle-products__pricing')
          );
        });
      }
    }

    function roots() {
      return Array.prototype.slice.call(document.querySelectorAll('.kaching-bundles'));
    }

    function applyAll() {
      roots().forEach(decorate);
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        applyAll();
      });
    }

    function watch() {
      schedule();
      var info = document.querySelector('.product__info-container') || document.body;
      var observer = new MutationObserver(schedule);
      observer.observe(info, { childList: true, subtree: true });
      new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: [ATTR] });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
    else watch();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__jcMegaMenuLazyBound) return;

  window.__jcMegaMenuLazyBound = true;

  document.addEventListener('DOMContentLoaded', () => {
    function initMegaSwiper(swiperEl) {
    if (!swiperEl) return;

    if (!swiperEl.swiper) {
        new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation: {
            nextEl: swiperEl.querySelector('.swiper-button-next'),
            prevEl: swiperEl.querySelector('.swiper-button-prev')
        }
        });
    }

    const instance = swiperEl.swiper;

    if (!instance) return;

    instance.updateSize();
    instance.updateSlides();
    instance.update();

    if (instance.navigation) {
        instance.navigation.update();
    }
    }

    document.querySelectorAll('.mega__menu__header').forEach(menu => {
      const buttons = Array.from(
        menu.querySelectorAll('.button__item[data-index]')
      );

      const templates = Array.from(
        menu.querySelectorAll('.mega-swiper-template')
      );

      const mount = menu.querySelector('.mega-swiper-mount');

      if (!buttons.length || !templates.length || !mount) return;

      const loadedSwipers = new Map();

      function getSwiper(index) {
        if (loadedSwipers.has(index)) {
          return loadedSwipers.get(index);
        }

        const template = templates.find(
          item => Number(item.dataset.index) === index
        );

        if (!template) return null;

        let html;

        try {
          html = JSON.parse(template.textContent);
        } catch (error) {
          return null;
        }

        const holder = document.createElement('template');
        holder.innerHTML = html.trim();

        const swiper = holder.content.querySelector('.swiper__mega_menu');

        if (!swiper) return null;

        mount.appendChild(holder.content);

        loadedSwipers.set(index, swiper);

        return swiper;
      }

      function activateSwiper(index) {
        const button = buttons.find(
          item => Number(item.dataset.index) === index
        );

        if (!button) return;

        buttons.forEach(item => {
          item.classList.remove('active');
        });

        loadedSwipers.forEach(swiper => {
          swiper.classList.remove('active');
        });

        const swiper = getSwiper(index);

        if (!swiper) return;

        button.classList.add('active');
        swiper.classList.add('active');

        requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            initMegaSwiper(swiper);
        });
        });
      }

      buttons.forEach(button => {
        const index = Number(button.dataset.index);

        button.addEventListener('mouseenter', () => {
          activateSwiper(index);
        });

        button.addEventListener('click', () => {
          activateSwiper(index);
        });
      });

      const owner = menu.closest('li');

      if (owner) {
        owner.addEventListener('mouseenter', () => {
          const activeButton =
            menu.querySelector('.button__item.active') || buttons[0];

          if (!activeButton) return;

          activateSwiper(Number(activeButton.dataset.index));
        });
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
